// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"LockSection_checkbox__V9UbX"};